<template lang="pug">
  .settings
      v-container.white.pa-0(style="max-width:600px")
        v-card(flat :outlined="$vuetify.breakpoint.smAndDown ? false : true" :class="$vuetify.breakpoint.smAndDown ? '' : 'mt-5'")
          //- orga setting
          .profile
            v-row.pa-4(no-gutters @click="$router.push('/admin/review/settings/profile')" style="cursor: pointer")
              v-col.shrink()
                eva-icon.ma-auto(name="settings-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text.capitalize {{ $t('profile') }}
                  .c1.basic600--text {{ $t('general_details') }}
            v-divider.basic300
          //- Subscription
          .subscription
            v-row.pa-4(no-gutters @click="$router.push('/admin/billing/review-subscription')" style="cursor: pointer")
              v-col.shrink()
                eva-icon.ma-auto(name="hard-drive-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text {{ $t('subscription') }}
                  .c1.basic600--text {{ $t('subscription_details') }}
            v-divider.basic300
          //- Bills
          .bills
            v-row.pa-4(no-gutters @click="$router.push('/admin/billing/review-bills')" style="cursor: pointer")
              v-col.shrink()
                eva-icon.ma-auto(name="file-text-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text {{ $t('bills') }}
                  .c1.basic600--text {{ $t('bills_details') }}
            v-divider.basic300
          //- Account settings
          v-row.pa-4(no-gutters @click="$router.push('/admin/review/settings/account')" style="cursor: pointer")
            v-col.shrink()
              eva-icon.ma-auto(name="person-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-col.pl-4
              div.my-auto
                .s1.basic800--text {{ $t('account') }}
                .c1.basic600--text {{ $t('account_details') }}
          v-divider.basic300
          //- Delete
          .delete
            v-row.pa-4(no-gutters @click="deleteCompanyDialog = !deleteCompanyDialog" style="cursor: pointer")
              v-col.shrink()
                eva-icon.ma-auto(name="trash-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
              v-col.pl-4
                div.my-auto
                  .s1.basic800--text {{ $t('delete') }}
                  .c1.basic600--text {{ $t('delete_details') }}
            v-divider.basic300

      .modals
        delete-company(v-if="deleteCompanyDialog" :open.sync="deleteCompanyDialog" :company="company")

</template>

<script>
import { mapState } from 'vuex'
import DeleteCompany from '@/components/dialogs/settings/DeleteCompany.vue'

export default {
  name: 'GeneralSettings',
  components: { DeleteCompany },
  props: ['company'],
  data () {
    return {
      showSubscribeModal: false,
      deleteCompanyDialog: false,
    }
  },
  computed: {
    ...mapState('user', ['member'])
  }
}
</script>

<i18n>
{
  "en": {
    "general": "General",
    "general_details": "Organization name, address, registration number",
    "account": "Account settings",
    "account_details": "Avatar, name, language, sign in methods, payment card",
    "notifications": "Notifications",
    "notifications_details": "Email and Application notifications",
    "books": "Yezza Books Settings",
    "books_details": "Accounting, customization, import and export data",
    "subscription": "Subscription",
    "subscription_details": "Current plan, next billing",
    "bills": "Bills",
    "bills_details": "List of previous bills",
    "zoo": "Zoo App",
    "zoo_details": "Zoo apps settings",
    "delete": "Delete Organization",
    "delete_details": "Stop using Yezza Review OS",
    "integration_details": "Webhook settings"
  },
  "id": {
    "general": "General",
    "general_details": "Nama Perusahaan, Alamat, Nomor Registrasi",
    "account": "Pengaturan Akun",
    "account_details": "Avatar, Nama, Bahasa, Metode sign in, Kartu pembayaran",
    "notifications": "Notifikasi",
    "notifications_details": "Email and Notifikasi Aplikasi",
    "books": "Pengaturan Yezza Books",
    "books_details": "Akuntansi, penyesuaian, impor dan ekspor data",
    "subscription": "Berlangganan",
    "subscription_details": "Paket saat ini, tagihan berikutnya",
    "bills": "Tagihan",
    "bills_details": "Daftar tagihan sebelumnya",
    "zoo": "Zoo App",
    "zoo_details": "Pengaturan Zoo App",
    "delete": "Pengaturan Hapus Akun",
    "delete_details": "Hapus Akun Perusahaan dari Yezza",
    "integration_details": "Webhook settings"
  }
}
</i18n>